/** @module Enums */ /** typedoc */
var ServiceStatusEnum;
(function (ServiceStatusEnum) {
    /**
     * Customer has not been activated.
     *
     * Other information: If a customer is in Draft mode, subscriptions will
     * not activate so no invoices will be generated.  Any subscriptions using
     * the Scheduled Activation date will not auto activate until customer's
     */
    ServiceStatusEnum["Draft"] = "Draft";
    /**
     * Customer is active
     */
    ServiceStatusEnum["Active"] = "Active";
    /**
     * Customer has been canceled.
     *
     * Other information: All processing for the customer will stop.
     */
    ServiceStatusEnum["Cancelled"] = "Cancelled";
    /**
     * Customer was placed into a Suspended state by the system.   A combination
     * of overdue invoices and surpassing the Account Grace Period control this state.
     *
     * Other information:  Customers in a Suspended or Hold status will not generate
     * new invoices but any scheduled collections will still occur.
     */
    ServiceStatusEnum["Suspended"] = "Suspended";
    /**
     * Customer has been manually placed into a Suspended state via the UI or
     * via an API call.
     *
     * Other information:  Customers in a Suspended or Hold status will not
     * generate new invoices but any scheduled collections will still occur.
     */
    ServiceStatusEnum["Hold"] = "Hold";
})(ServiceStatusEnum || (ServiceStatusEnum = {}));

export { ServiceStatusEnum };
